<template>
  <div class="page-container" style="padding-bottom: 20px">
    <div style="margin: auto">
      <!-- <err-404 class="page-404-background err-404" /> -->
      <err-404-moblie class="page-404-background" />
      <h3
        style="
          color: #d50000 !important;
          caret-color: #d50000 !important;
          font-size: 3rem !important;
          line-height: 3.125rem;
          letter-spacing: normal !important;
          text-align: center;
        "
        class="red--text text--accent-4 text-h3 font-weight-bold mt-sm-10 mb-3"
      >
        خطای 404
      </h3>
      <h5 style="text-align: center">صفحه پیدا نشد</h5>
      <button
        style="
          height: 52px;
          min-width: 92px;
          padding: 0 23.1111111111px;
          background-color: #f57c00 !important;
          border-color: #f57c00 !important;
          font-size: 1rem;
          color: #fff;
          margin-top: 28px !important;
          margin-bottom: 28px !important;
          border-radius: 28px;
          margin-right: 32%;
        "
        to="/"
      >
        بازگشت به صفحه اصلی
      </button>
    </div>
  </div>
</template>

<script>
import Err404Moblie from "@/components/error/404mobileIcon.vue";
export default {
  components: {
    Err404Moblie,
  },
};
</script>

<style scoped>
.page-404-background {
  width: 90%;
  height: 100%;
  margin-right: 5%;
}
</style>